const messagesInItalian = {
    financialServices: "Servizi finanziari",
  };
  
  export { messagesInItalian };
  